export default {
  methods: {
    calculateScore(key) {
      let sc = 0;
      if (typeof key !== "undefined") {
        return this.$store.state.scoreBoard[key];
      }
      // eslint-disable-next-line no-unused-vars
      for (const scoreEntry in this.$store.state.scoreBoard) {
        const scoreValue = this.$store.state.scoreBoard[scoreEntry];
        sc += scoreValue;
      }
      return sc;
    },
    isScoredPage(page) {
      return page.options.scored || page.options.mode === "quiz";
    },
    getMaxScore() {
      const answers = [];
      // eslint-disable-next-line no-unused-vars
      for (const key in this.$store.state.answers) {
        answers.push(key);
      }
      let max = 0;
      const pages = this.$store.state.config.pages;
      for (let i = 0; i < pages.length; i++) {
        const page = pages[i];
        if (
          page.type === "SurveyPage" &&
          this.isScoredPage(page) &&
          answers.indexOf(page.options.key) !== -1
        ) {
          if (
            page.options.type === "SingleSelect" ||
            page.options.type === "QuizSelect" ||
            page.options.type === "PollSelect"
          ) {
            let maxAnswer = 0;
            page.options.answers.forEach((answer) => {
              if (answer.score > maxAnswer) {
                maxAnswer = answer.score;
              }
            });
            max += maxAnswer;
          }
          if (page.options.type === "MultiSelect" && !page.options.maxScore) {
            page.options.answers.forEach((answer) => {
              max += answer.score;
            });
          }
          if (page.options.type === "MultiSelect" && page.options.maxScore) {
            max = page.options.maxScore;
          }
        }
      }
      return max;
    },
    getScoreBand(pc, bands) {
      if (!bands || typeof bands === "undefined") {
        bands = [
          { score: 0, message: "Very poor", more: "", image: "" },
          { score: 25, message: "Poor", more: "", image: "" },
          { score: 50, message: "Average", more: "", image: "" },
          { score: 75, message: "Good", more: "", image: "" },
          { score: 100, message: "Great", more: "", image: "" }
        ];
      }
      let scoreBand;
      bands.forEach(function(band, i) {
        if (pc >= band.score) {
          scoreBand = band;
          scoreBand.index = i;
        }
      });
      return scoreBand;
    },
    getScore(key) {
      if (this.debugMode === true) {
        this.score = this.calculateScore();
        this.scorePercent = this.percentScore();
        this.scoreText = this.displayScore();
        return;
      }
      this.convince.ranking(key).then(
        function(res) {
          this.score = res.data.final_score;
          this.scorePercent = this.percentScore();
          this.scoreText = this.displayScore();
        }.bind(this)
      );
    },
    getBreakdown(key, callback) {
      this.convince.breakdown(key).then(function(res) {
        callback(res.data);
      });
    },
    asPercentage(score, maxScore) {
      return (score / maxScore) * 100;
    },
    displayScore(score, max, as) {
      let dScore = "";
      switch (as) {
        case "score":
          dScore = score + "<span>out of " + max + "</span>";
          break;
        case "percentage":
          dScore = this.displayPercentScore(score, max) + "%";
          break;
        case "custom":
          dScore = this.displayCustomScore(this.percentScore(score, max));
          break;
        case "none":
          dScore = "";
          break;
      }
      return dScore;
    },
    displayImage(pcScore) {
      return this.getScoreBand(pcScore, this.config.bands).image || false;
    },
    displayMessage(pcScore) {
      return this.getScoreBand(pcScore, this.config.bands).message || false;
    },
    displayMore(pcScore) {
      return this.getScoreBand(pcScore, this.config.bands).more || false;
    },
    displayCustomScore(pcScore) {
      return this.getScoreBand(pcScore, this.config.bands).display || false;
    },
    displayPercentScore(score, max) {
      return Math.round(this.percentScore(score, max));
    },
    percentScore(score, max) {
      return this.asPercentage(score, max);
    }
  }
};
